import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-intent-start-arrow",
  "use": "icon-intent-start-arrow-usage",
  "viewBox": "0 0 8 15",
  "content": "<symbol viewBox=\"0 0 8 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-intent-start-arrow\">\n<path id=\"icon-intent-start-arrow_Vector\" d=\"M1 13.5L7 7.5L1 1.5\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol